import { IoTNodesSVG } from '../components/TechIllustrations';

const ContactPage = () => (
  <div className="bg-white">

    {/* ── Page header ── */}
    <div className="border-b border-slate-200 bg-slate-50 py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <span className="section-label">Contact Us</span>
        <h1 className="mt-3 text-3xl font-bold text-slate-900 sm:text-4xl">
          Let's Talk About Your Project
        </h1>
        <p className="mt-3 max-w-2xl text-slate-500 leading-6">
          Whether you need IoT systems, robotics, electronics, training, or consulting —
          BETRobionics is ready to help. We respond within 24 hours.
        </p>
      </div>
    </div>

    {/* ── Content ── */}
    <section className="py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-start">

          {/* Left: form + contact info */}
          <div className="space-y-6">

            {/* Contact info blocks */}
            <div className="grid gap-4 sm:grid-cols-3">
              {[
                { label: 'Email', value: 'contact@betr.bi', href: 'mailto:contact@betr.bi', color: 'green',
                  icon: <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" /></svg> },
                { label: 'Phone', value: '+257 67 70 62 85', href: 'tel:+25767706285', color: 'red',
                  icon: <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" /></svg> },
                { label: 'Location', value: 'Bujumbura, Burundi', href: null, color: 'green',
                  icon: <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" /></svg> },
              ].map(({ label, value, href, color, icon }) => (
                <div key={label} className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                  <div className={`mb-2 flex h-9 w-9 items-center justify-center rounded-lg ${color === 'green' ? 'bg-[#1aa534]/10 text-[#1aa534]' : 'bg-[#d2252e]/10 text-[#d2252e]'}`}>
                    {icon}
                  </div>
                  <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-400">{label}</p>
                  {href
                    ? <a href={href} className={`mt-0.5 block text-sm font-medium ${color === 'green' ? 'text-[#1aa534]' : 'text-[#d2252e]'} hover:underline`}>{value}</a>
                    : <p className="mt-0.5 text-sm font-medium text-slate-700">{value}</p>}
                </div>
              ))}
            </div>

            {/* Action buttons */}
            <div className="space-y-3">
              <a href="mailto:contact@betr.bi" className="btn-primary-lg w-full justify-center">
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" /></svg>
                Send us an Email
              </a>
              <a href="tel:+25767706285" className="btn-red w-full justify-center">
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" /></svg>
                Call +257 67 70 62 85
              </a>
            </div>

            {/* What we help with */}
            <div className="rounded-xl border border-slate-200 bg-white p-5">
              <p className="mb-3 text-sm font-semibold text-slate-700">What we can help with</p>
              <div className="grid grid-cols-2 gap-2">
                {['IoT Deployment','Electronics Design','Robotics Build','AI & ML Models',
                  'Training Program','Smart City','Consulting','E-commerce'].map(item => (
                  <div key={item} className="flex items-center gap-2 text-sm text-slate-600">
                    <span className="h-1.5 w-1.5 rounded-full bg-[#1aa534]" />{item}
                  </div>
                ))}
              </div>
            </div>

            {/* Commitment */}
            <div className="rounded-xl border border-[#1aa534]/20 bg-[#1aa534]/[0.04] p-5">
              <p className="mb-2 text-sm font-semibold text-[#1aa534]">Our commitment</p>
              <ul className="space-y-1.5">
                {['Response within 24 hours','Free initial consultation',
                  'Transparent pricing','Solutions built for African realities'].map(item => (
                  <li key={item} className="flex items-center gap-2 text-sm text-slate-600">
                    <svg className="h-4 w-4 shrink-0 text-[#1aa534]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right: IoT nodes illustration */}
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-6 lg:sticky lg:top-24">
            <p className="mb-3 text-center text-[10px] font-semibold uppercase tracking-widest text-[#1aa534]">
              Connected Systems We Build
            </p>
            <IoTNodesSVG className="w-full" />
            <div className="mt-6 space-y-3">
              <div className="flex items-center gap-2 rounded-lg bg-white border border-slate-200 px-4 py-3 text-sm">
                <span className="h-2 w-2 rounded-full bg-[#1aa534] animate-pulse" />
                <span className="text-slate-700 font-medium">Smart Agriculture Systems</span>
              </div>
              <div className="flex items-center gap-2 rounded-lg bg-white border border-slate-200 px-4 py-3 text-sm">
                <span className="h-2 w-2 rounded-full bg-[#d2252e] animate-pulse" />
                <span className="text-slate-700 font-medium">Urban Safety Networks</span>
              </div>
              <div className="flex items-center gap-2 rounded-lg bg-white border border-slate-200 px-4 py-3 text-sm">
                <span className="h-2 w-2 rounded-full bg-[#1aa534] animate-pulse" />
                <span className="text-slate-700 font-medium">Industrial Automation</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default ContactPage;
